import { Component } from '@angular/core';

@Component({
    selector: 'inka-space',
    templateUrl: './space.component.html',
    styleUrl: './space.component.scss',
    standalone: false
})
export class SpaceComponent {

}
